module.exports = __webpack_public_path__ + "img/Unidad7-1.9687dfe6.png";